// Version info - auto-generated at build time
// DO NOT EDIT MANUALLY - This file is updated by scripts/update-version.js

import versionInfo from './version.json';

// Format date for French locale
const formatBuildDate = (isoDate) => {
  const date = new Date(isoDate);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit', 
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const APP_VERSION = versionInfo.version || '2.0.0';
export const BUILD_DATE = formatBuildDate(versionInfo.buildDate);
export const BUILD_TIMESTAMP = versionInfo.buildTimestamp;
